import defaultState from '../state/defaultState'
import filterOptions from './filterOptions'

const init = (props, state) => {
  const {
    name,
    options,
    createTags = true,
    payload,
    validationRules,
    reset = false
  } = props

  let resetState = !state.get(`selectr.${name}`)
  if (reset) {
    resetState = true
  }

  if (resetState) {
    state.set(`selectr.${name}`, {
      options: filterOptions(options, false),
      selected: filterOptions(options, true),
      createTags,
      payload,
      ...defaultState,
      validationRules: validationRules || []
    })
  }
}

export default init
